import React from "react";
import _ from "lodash";

export default function SelectField(props) {
  const {
    field: { name, label, options, required },
    i,
    value,
    handleOnChange
  } = props;
  return (
    <div className={`item-${i} form-group`}>
      <label>
        {label}:
        {required ? <span className="required"> *</span> : null}
      </label>
      <select
        name={name}
        value={value}
        onChange={handleOnChange}
        className="form-control"
      >
        <option value="">-- Selecione una opción --</option>
        {_.map(options, ({ name, value, label }) => (
          <option value={value} key={name}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/User/UserDetailsForm/renderFields/SelectField.js